import { defineStore } from 'pinia';

export const usePrintStore = defineStore('print', {
  state () {
    return {
      letterRatio: {
        long: 1.29411764706,
        short: 0.77272727272,
        base: 1260,
      }, // 0.77272727272,
      a4Ratio: {
        long: 1.414285714285714,
        short: 0.70707070707,
        base: 1400,
      },
      size: 'letter', // a4 / letter
      orientation: 'landscape', // portrait / landscape
      printIsOpen: false,
      printDebug: 0,
      pageScale: 1,
      printInput: {
        notes: 'sample notes here',
        jobTitle: 'test',
      },
      printData: [
        // TODO: need to validate and replace incorrect values/references
        // TODO: *** means highly unsure

        {
          group: 1,
          data: [
            { label: 'Client', value: 'client' },
            { label: 'Job Number', value: 'jobNumber' },
            { label: 'Date', value: 'date' },
            { label: 'Job Description', value: 'jobDescription' },
            { label: 'Designer', value: 'designer' },
          ],
        },
        {
          group: 1,
          data: [
            { label: 'Pressure Variation', value:'pressureVariation', unit:'pressure' },
            { label: 'Pressure Difference', value:'pressureDifference', unit:'pressure' },
            { label: 'Flow Variation', value:'flowVariation', unit: 'flow' },
            { label: 'Flow Difference', value:'flowDifference', unit: 'flow' },
            { label: 'Inlet Position', value:'submainPosition', unit: 'length' },
            { label: 'Inlet Pressure', value:'inletPressure', unit: 'flow' },
            { label: 'Total Flow', value:'totalFlow', unit: 'flow' },
          ]
        },
        {
          group: 2,
          data: [
            { label: 'Nozzle Height', value: 'nozzleHeight', unit: 'length' },
            { label: 'Pressure', value: 'pressure', unit: 'height' },
            { label: 'Flow', value: 'flow', unit: 'mins' },
            { label: 'Duration', value: 'duration', unit: 'height', type: 'divider' },
            { label: 'Rotation Speed', value: 'rotationSpeed', unit: 'length' },
            { label: 'Air Temp', value: 'airTemp', unit: 'speed', type: 'divider' },
            { label: 'Water Temp', value: 'waterTemp', unit: 'speed' },
          ],
        },
        {
          group: 3,
          data: [
            { label: 'Cup Area', value: '', unit: 'spacing' },
            { label: 'mL', value: '', unit: 'length' },
            { label: 'in^3', value: '', unit: 'gal' },
          ],
        },
        {
          group: 4,
          data: [
            { label: 'Est Applied Vol', value: 'appliedVolume', unit: 'gal' },
            { label: 'Est Catch Vol', value: 'catchVolume', unit: 'gal' },
            { label: 'Capture Error', value: 'captureError', unit: '%', color: 'green', type: 'divider' },
            { label: 'S2S Difference', value: 'sideToSideDelta', unit: '%', color: 'red' },
          ],
        },
      ],
      currentPrintPage: 0,
      maxCatchDataEntries: 40,
      printMonochrome : true
    };
  },
  getters: {
    getPrintMonochrome () {
      return this.printMonochrome;
    },
    getMaxCatchDataEntries () {
      return this.maxCatchDataEntries;
    },
    getPrintIsOpen () {
      return this.printIsOpen;
    },
    getSize () {
      return this.size;
    },
    getOrientation () {
      return this.orientation;
    },
    getPageScale () {
      return this.pageScale;
    },
    getJobTitle () {
      return this.printInput.jobTitle;
    },
    getJobNotes () {
      return this.printInput.notes;
    },
    getPrintQueue () {
      return Math.ceil(Math.max(0,10) / this.getMaxCatchDataEntries);
    },
    getCurrentPrintPage () {
      return this.currentPrintPage;
    },
    getTotalPrintPages () {
      return this.getPrintQueue;
    },
    getDimensions () {
      let sizeRatio = this.size === 'letter' ? this.letterRatio : this.a4Ratio;
      return this.orientation === 'landscape'
        ? { width: sizeRatio.base, height: sizeRatio.base * sizeRatio.short }
        : { width: sizeRatio.base * sizeRatio.short, height: sizeRatio.base };
    },
  },
  actions: {
    setPrintMonochrome (value) {
      this.printMonochrome = value;
    },
    getPrintDataAtIndex (index) {
      return this.printData[index];
    },
    setPrintIsOpen (bool) {
      this.printIsOpen = bool;
      if (!bool) { this.setPageScale(1); }
    },
    setSize (type) {
      this.size = type;
    },
    setOrientation (type) {
      this.orientation = type;
    },
    setPageScale (val) {
      this.pageScale = Math.min(val, 1);
    },
    setJobTitle (val) {
      this.printInput.jobTitle = val;
    },
    setJobNotes (val) {
      this.printInput.notes = val;
    },
    showPrintPage (num) {
      this.currentPrintPage += num;
    },
  },
});
